
import { Home, Users, Trophy, MessageSquare } from 'lucide-react';
import { ROUTES } from './routes';

export const NAVIGATION_ITEMS = [
  { 
    icon: Home, 
    labelKey: 'nav.home',
    path: ROUTES.HOME,
    key: 'home'
  },
  { 
    icon: Users, 
    labelKey: 'nav.groups',
    path: ROUTES.GROUPS,
    key: 'groups'
  },
  { 
    icon: Trophy, 
    labelKey: 'nav.matches',
    path: ROUTES.MATCHES,
    key: 'matches'
  },
  { 
    icon: MessageSquare, 
    labelKey: 'nav.messages',
    path: ROUTES.MESSAGES,
    key: 'messages'
  }
] as const;

export type NavigationItem = typeof NAVIGATION_ITEMS[number];
